import { Component, DestroyRef, Input, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { SitecoreMyBetsConfig } from '@frontend/sports/common/client-config-data-access';
import { TrackingService, trackingConstants } from '@frontend/sports/tracking/feature';
import { Subject, throttleTime } from 'rxjs';

import { MigrationTabType, MyBetsBetSlip, MyBetsListContext } from '../../../my-bets-base/models/my-bets-viewmodels';
import { MyBetsPinningService } from '../../services/my-bets-pinning.service';

@Component({
    selector: 'ms-my-bets-pin',
    templateUrl: 'my-bets-pin.html',
    standalone: false,
})
export class MyBetsPinComponent implements OnInit {
    @Input() betslip: MyBetsBetSlip;
    @Input() myBetsListContext: MyBetsListContext;
    private click$ = new Subject<void>();
    private readonly destroyRef = inject(DestroyRef);

    constructor(
        private myBetsPinningService: MyBetsPinningService,
        private sitecoreMyBets: SitecoreMyBetsConfig,
        private trackingService: TrackingService,
    ) {}

    ngOnInit(): void {
        this.click$.pipe(throttleTime(250), takeUntilDestroyed(this.destroyRef)).subscribe(() => {
            this.myBetsPinningService.togglePin({
                betslipNumber: this.betslip.betslipId,
                isMigratedBet: this.myBetsListContext.migrationTabType === MigrationTabType.Before,
            });

            if (this.isPinned) {
                this.trackingService.track(trackingConstants.EVENT_PAGE_VIEW, {
                    [trackingConstants.PAGE_NAME]: (this.myBetsListContext.isEventView ? 'EventView' : 'myBets') + '_PinBet',
                });
            } else {
                this.trackingService.track(trackingConstants.EVENT_PAGE_VIEW, {
                    [trackingConstants.PAGE_NAME]: (this.myBetsListContext.isEventView ? 'EventView' : 'myBets') + '_UnPinBet',
                });
            }
        });
    }

    get isPinned(): boolean {
        return this.myBetsPinningService.isPinned(this.betslip.betslipId, this.myBetsListContext.migrationTabType === MigrationTabType.Before);
    }

    get pinText(): string {
        return this.isPinned ? this.sitecoreMyBets.myBets.UnpinBet : this.sitecoreMyBets.myBets.PinToTop;
    }

    togglePin(): void {
        this.click$.next();
    }
}
